var map = {
	"./device-Information_0.png": "bf51",
	"./device-Information_0_v1.png": "5a7b",
	"./device-Information_1.png": "c504",
	"./device-Information_1_v1.png": "9bf7",
	"./device-Information_2.png": "95ac",
	"./device-Information_2_v1.png": "7733",
	"./device-Information_3.png": "2651",
	"./device-Information_3_v1.png": "3911"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b28a";